import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, permission, allowedRoles, disallowRoles, platformOnly = false }) => {
  const { user, loading, hasPermission } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"/>
    </div>
  );
  if (!user) {
    return <Navigate to="/login" />;
  }
  if (platformOnly && user.is_platform_admin !== true) {
    return <Navigate to="/" replace />;
  }
  if (Array.isArray(allowedRoles) && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  if (Array.isArray(disallowRoles) && disallowRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
